// extracted by mini-css-extract-plugin
export default {"anchor":"anchor_anchor__MqJWT","hover__effect":"anchor_hover__effect__nLC16"};